import React, { useRef, useState } from "react";
import {
Modal,
Tab,
Nav,
Form,
Row,
Col,
Button
} from "react-bootstrap";
import { TiTimes } from "react-icons/ti";
import { FiEyeOff } from "react-icons/fi";

export default function EditBasicInfoModal  ({ show, onHide })  {

const [activeTab,setActiveTab]=useState("basic");
const [profileImg,setProfileImg] = useState(
"https://randomuser.me/api/portraits/men/32.jpg"
);

const fileInputRef = useRef(null);

const handleUploadClick = () => {
fileInputRef.current.click();
};

const handleFileChange = (e) => {
const file = e.target.files[0];

if(file){
const imageUrl = URL.createObjectURL(file);
setProfileImg(imageUrl);
}
};

const handleCancelImage = () => {
setProfileImg(
"https://randomuser.me/api/portraits/men/32.jpg"
);
};
return (
<Modal show={show} onHide={onHide} size="lg"
centered>
<Modal.Header
style={{
borderBottom:"1px solid #e5e7eb",
padding:"18px 24px",
position:"relative"
}}
>
<div>
<h4 style={{margin:0,fontWeight:"700"}}>
Edit Employee
<span
style={{
fontSize:"16px",
fontWeight:"400",
marginLeft:"10px"
}}
>
Employee ID : EMP-0024
</span>
</h4>
</div>

<button
onClick={onHide}
style={{
position:"absolute",
right:"20px",
top:"14px",
border:"none",
background:"#6b7280",
width:"28px",
height:"28px",
borderRadius:"50%",
color:"#fff"
}}
>
<TiTimes/>
</button>

</Modal.Header>

<Modal.Body style={{padding:"20px 24px 10px"}}>

<Tab.Container activeKey={activeTab}>
<Nav
variant="underline"
style={{
borderBottom:"1px solid #e5e7eb",
marginBottom:"28px",
gap:"20px"
}}
>
<Nav.Item>
<Nav.Link
eventKey="basic"
onClick={()=>setActiveTab("basic")}
style={{
color:activeTab==="basic" ? "#f97316" : "#64748b"
}}
>
Basic Information
</Nav.Link>
</Nav.Item>

<Nav.Item>
<Nav.Link
eventKey="permissions"
onClick={()=>setActiveTab("permissions")}
style={{
color:activeTab==="permissions" ? "#f97316" : "#64748b"
}}
>
Permissions
</Nav.Link>
</Nav.Item>

</Nav>

<Tab.Content>

{/* BASIC INFO TAB */}

<Tab.Pane eventKey="basic">

<div
style={{
background:"#f8fafc",
padding:"20px",
borderRadius:"8px",
marginBottom:"24px"
}}
>
<div style={{display:"flex",alignItems:"center",gap:"14px"}}>

<img
src={profileImg}
alt=""
style={{
width:"58px",
height:"58px",
borderRadius:"50%",
objectFit:"cover"
}}
/>

<div>

<div style={{fontWeight:"600"}}>
Upload Profile Image
</div>

<div
style={{
fontSize:"13px",
color:"#64748b",
marginBottom:"8px"
}}
>
Image should be below 4 mb
</div>

<input
type="file"
accept="image/*"
ref={fileInputRef}
onChange={handleFileChange}
style={{display:"none"}}
/>

<Button
size="sm"
onClick={handleUploadClick}
style={{
background:"#f97316",
border:"none",
marginRight:"8px"
}}
>
Upload
</Button>

<Button
size="sm"
variant="light"
onClick={handleCancelImage}
style={{border:"1px solid #ddd"}}
>
Cancel
</Button>

</div>
</div>
</div>

<Row>
<Col md={6}>
<Field label="First Name*" value="Anthony"/>
</Col>

<Col md={6}>
<Field label="Last Name" value="Lewis"/>
</Col>

<Col md={6}>
<Field label="Employee ID*" value="Emp-001"/>
</Col>

<Col md={6}>
<Field label="Joining Date*" value="17-10-2022"/>
</Col>

<Col md={6}>
<Field label="Username*" value="Anthony"/>
</Col>

<Col md={6}>
<Field label="Email*" value="[email protected]"/>
</Col>
<Col md={6}>
<Form.Group className="mb-3">
<Form.Label>Password *</Form.Label>

<div style={{position:"relative"}}>
<Form.Control
type="password"
style={{paddingRight:"42px"}}
/>

<FiEyeOff
style={{
position:"absolute",
right:"14px",
top:"50%",
transform:"translateY(-50%)",
fontSize:"18px",
color:"#111827",
cursor:"pointer"
}}
/>
</div>

</Form.Group>
</Col>


<Col md={6}>
<Form.Group className="mb-3">
<Form.Label>Confirm Password *</Form.Label>

<div style={{position:"relative"}}>
<Form.Control
type="password"
style={{paddingRight:"42px"}}
/>

<FiEyeOff
style={{
position:"absolute",
right:"14px",
top:"50%",
transform:"translateY(-50%)",
fontSize:"18px",
color:"#111827",
cursor:"pointer"
}}
/>
</div>

</Form.Group>
</Col>
<Col md={6}>
<Field label="Phone Number*" value="(123)4567 890"/>
</Col>

<Col md={6}>
<Field label="Company*" value="Abac Company"/>
</Col>

<Col md={6}>
<Field label="Department" value="Finance"/>
</Col>

<Col md={6}>
<Field label="Designation" value="Finance"/>
</Col>

<Col md={12}>
<Form.Group className="mb-3">
<Form.Label>About*</Form.Label>
<Form.Control
as="textarea"
rows={3}
defaultValue="As an award winning designer, I deliver exceptional quality work and bring value to your brand."
/>
</Form.Group>
</Col>

</Row>

</Tab.Pane>

{/* PERMISSIONS TAB */}

<Tab.Pane eventKey="permissions">

<div
style={{
background:"#f8fafc",
padding:"18px",
borderRadius:"8px",
marginBottom:"20px",
fontWeight:"600"
}}
>
Enable Options
</div>

<div style={{border:"1px solid #e5e7eb"}}>

{[
"Holiday",
"Leaves",
"Clients",
"Projects",
"Tasks",
"Chats",
"Assets",
"Timing Sheets"
].map((item,i)=>(

<div
key={i}
style={{
display:"grid",
gridTemplateColumns:"120px repeat(6,1fr)",
padding:"14px 16px",
borderBottom:"1px solid #e5e7eb",
alignItems:"center"
}}
>

<Form.Check
type="switch"
label={item}
defaultChecked={item==="Holiday" || item==="Assets"}
/>

<Form.Check label="Read"/>
<Form.Check label="Write"/>
<Form.Check label="Create"/>
<Form.Check label="Delete"/>
<Form.Check label="Import"/>
<Form.Check label="Export"/>

</div>

))}

</div>

</Tab.Pane>

</Tab.Content>
</Tab.Container>

</Modal.Body>

<Modal.Footer
style={{
borderTop:"1px solid #e5e7eb"
}}
>
<Button
variant="light"
onClick={onHide}
style={{border:"1px solid #ddd"}}
>
Cancel
</Button>

<Button
style={{
background:"#f97316",
border:"none"
}}
>
Save
</Button>

</Modal.Footer>

</Modal>
);
}

function Field({label,value}){
return(
<Form.Group className="mb-3">
<Form.Label>{label}</Form.Label>
<Form.Control defaultValue={value}/>
</Form.Group>
);
}